import React from 'react'
import Skeleton from 'react-loading-skeleton'
import SkeletonInputField from './InputField/Skeleton'

import useStyles from '../../styles/common/stepForms'

function SkeletonForm({ className }) {
  const classes = useStyles()

  return (
    <div className={className}>
      <div className={classes.stepTitle}>
        <Skeleton width={320} />
      </div>
      <SkeletonInputField />
    </div>
  )
}

export default SkeletonForm
